import React from 'react';
import styles from './index.module.scss';
import AllBrands from '../../assets/images/AllBrands.svg';
import AllOffers from '../../assets/images/AllOffers.svg';
import rigthArrow from '../../assets/images/rigthArrow.svg';
import { useIdHash, useNavigateRoute } from '../../hooks/custom.hooks';
import FadeInSection from '../../wrapper/FadeInWrapper';

function OffersAndBrandSection() {
  const { isApp } = useIdHash();
  const offerAndBrand = [
    {
      key: 1,
      img: AllBrands,
      text: 'Show All Offers',
      redirection: `/offers`,
      hideSection: false,
    },
    {
      key: 2,
      img: AllOffers,
      text: 'Check all Brands',
      redirection: `/brands`,
      hideSection: !isApp,
    },
  ];
  const navigateRoute = useNavigateRoute();
  return (
    <FadeInSection>
      <div className={styles.sectionContainer}>
        <div className={styles.seprateSection}>
          {offerAndBrand?.map((element) => {
            return (
              <>
                {!element.hideSection ? (
                  <div
                    key={element?.key}
                    onClick={() =>
                      navigateRoute({ nextPage: element?.redirection })
                    }
                  >
                    <div className={styles?.mainSection}>
                      <div>
                        <img src={element?.img} alt="AllBrands" />
                        <div className={styles.text}>{element?.text}</div>
                      </div>
                      <img src={rigthArrow} alt="rigthArrow" />
                    </div>
                  </div>
                ) : null}
              </>
            );
          })}
        </div>
      </div>
    </FadeInSection>
  );
}
export default React.memo(OffersAndBrandSection);
